import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: none; }
`;

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
  padding: 56px 32px 96px;
`;

export const ContentGrid = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 236px 1fr;
  gap: 56px;
  align-items: start;
`;

export const Sidebar = styled.aside`
  position: sticky;
  top: 56px;
  align-self: start;
`;

export const LogoWrapper = styled.div`
  margin-bottom: 24px;
`;

export const TocLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #98a2b3;
  margin-bottom: 14px;
`;

export const TocNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

interface TocLinkProps {
  $active: boolean;
}

export const TocLink = styled.a<TocLinkProps>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: ${({ $active }) => ($active ? '#6241ea' : '#475467')};
  text-decoration: none;
  transition: color 0.15s;
`;

export const TocLinkBar = styled.span<TocLinkProps>`
  flex-shrink: 0;
  width: 3px;
  height: 18px;
  border-radius: 9999px;
  background: ${({ $active, theme }) => ($active ? theme.colors.bopsPurple : theme.colors.cardBorder)};
  transition: all 0.15s;
`;

export const MainCard = styled.main`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.08);
  padding: 56px 60px 64px;
  animation: ${fadeIn} 0.5s ease-in-out;
  min-width: 0;
`;

export const CardHeader = styled.header`
  margin-bottom: 40px;
`;

export const BadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
`;

export const CardTitle = styled.h1`
  font-size: 34px;
  line-height: 1.18;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #101828;
  margin: 0 0 16px;
  text-wrap: balance;
`;

export const CardSubtitle = styled.p`
  font-size: 17px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.cardBox};
  margin: 0;
  max-width: 62ch;
`;

export const CardFooter = styled.footer`
  margin-top: 56px;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.cardBorder};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
`;

export const FooterLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
`;

export const FooterText = styled.span`
  font-size: 13px;
  color: #98a2b3;
`;

export const FooterLink = styled.a`
  color: #6241ea;
  text-decoration: none;
`;
